<template>
    <ul 
        class="dropdown-menu dropdown--menu"  
        :aria-labelledby="`${id}DropDown`"
        :class="[widthType]"
        v-bind="$attrs"
    >
        <slot />
    </ul>
</template>

<script>
export default {
    name: "List",
    
    props: {
        id: {
            type: String,
            default: "",
        },

        widthType: {
            type: String,
            default: "fit",
            validator: (value) => {
                return ["fit", "wide"].includes(value);
            },
        },
    },
};
</script>